import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  content: {
    padding: '0 4px'
  },
  section: {
    marginBottom: 20
  },
  sectionTitle: {
    marginBottom: 12
  },
  addControl: {
    marginBottom: 8
  },
  list: {
    maxHeight: 240,
    overflowY: 'auto'
  },
  listRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: 8,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E0E0E0',
    marginBottom: 8,
    '&:last-child': {
      marginBottom: 0
    }
  },
  listRowMain: {
    flex: 1,
    minWidth: 0,
    '& > *': {
      display: 'block'
    }
  },
  listRowRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0
  },
  scopeLabel: {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    gap: 8
  },
  checkboxLabel: {
    marginTop: 4
  },
  autocomplete: {
    width: '100%',
    '& .MuiFormControl-root .MuiInputBase-root': {
      paddingTop: '10px',
      paddingBottom: '9px'
    },
    '& .MuiFormLabel-root': {
      transform: 'translate(12px, 12px) scale(1)'
    }
  },
  addPricingHeaderItem: {
    opacity: 1,
    cursor: 'default',
    backgroundColor: '#E1E7EC',
    '&.Mui-focusVisible': {
      backgroundColor: '#E1E7EC'
    }
  },
  warningChip: {
    width: '100%',
    padding: '8px',
    marginBottom: 16,
    justifyContent: 'flex-start',
    '& .MuiSvgIcon-root': {
      marginRight: 4
    }
  },
  noActiveProperties: {
    '&.Mui-disabled': {
      display: 'block'
    }
  },
  defaultPriceSets: {
    display: 'flex',
    margin: '0 -4px',
    '& .MuiButton-root': {
      margin: '0 4px 8px 4px'
    }
  }
});
export default useStyles;